/**
 * Legacy compatibility wrapper for useDataManager
 * This now uses the new modular architecture with useDebts
 * 
 * @deprecated Use useDebts instead for new code
 */

import { useDebts, useDebt as useDebtNew, useMonthlyPayments as useMonthlyPaymentsNew } from './useDebts';

/**
 * @deprecated Use useDebts instead
 */
export const useDataManager = () => {
  const debtsHook = useDebts();
  
  // Add analytics placeholder for backward compatibility
  const analytics = debtsHook.data.analytics || {};
  const updateAnalytics = () => {
    // Analytics functionality can be implemented later if needed
    console.warn('[useDataManager] Analytics functionality moved to separate module');
    return Promise.resolve(analytics);
  };

  return {
    ...debtsHook,
    analytics,
    updateAnalytics,
    // Legacy aliases
    hasPaymentHistory: debtsHook.paymentHistory.length > 0,
    hasProjections: debtsHook.projections && debtsHook.projections.months && debtsHook.projections.months.length > 0
  };
};

/**
 * @deprecated Use useDebt from './useDebts' instead
 */
export const useDebt = useDebtNew;

/**
 * @deprecated Use useMonthlyPayments from './useDebts' instead
 */
export const useMonthlyPayments = useMonthlyPaymentsNew;

export default useDataManager;